import { useEffect, useState } from 'react';
import Card from 'components/card';
import GsheetImg from 'assets/gsheet.png';
import { useNavigate, useParams } from 'react-router-dom';

import boltImg from 'assets/img/cms/bolt.png';
import shopifyImg from 'assets/img/cms/shopify.png';
import bubbleImg from 'assets/img/cms/bubble.png';
import htmlImg from 'assets/img/cms/html.jpg';
import landbotImg from 'assets/img/cms/landbot.jpg';
import prestaShopImg from 'assets/img/cms/prestashop.svg';
import systemIoImg from 'assets/img/cms/system.svg';
import webflowImg from 'assets/img/cms/webflow.png';
import unbouncedImg from 'assets/img/cms/unbounced.jpg';
import wordpressImg from 'assets/img/cms/wordpress.png';
import { CONFIG } from 'variables/config';
import axios from 'axios';

const IntegrateSpecificOffer = () => {
    const [loading] = useState(false);
    const [selectedService, setSelectedService] = useState(null);
    const [user, setUser] = useState(null);
    const [offer, setOffer] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const params = useParams();
    const [services] = useState([
        {
            name: 'Wordpress',
            service: 'wordpress',
            description:
                'Vos leads automatiquement envoyés à Leadrs depuis votre cms Wordpress.',
            logo: wordpressImg,
            status: 'not-setup',
            source: '',
        },
        {
            name: 'Webflow',
            service: 'webflow',
            description:
                'Vos leads automatiquement envoyés à Leadrs depuis votre cms Webflow.',
            logo: webflowImg,
            status: 'not-setup',
            source: 'https://embed.app.guidde.com/playbooks/p8M2gA5SfVzg9FMHWK69Vm',
        },
        {
            name: 'HTML',
            service: 'html',
            description:
                'Vos leads automatiquement envoyés à Leadrs depuis votre propre site.',
            logo: htmlImg,
            status: 'not-setup',
            source: '',
        },
        {
            name: 'Shopify',
            service: 'shopify',
            description:
                'Vos leads automatiquement envoyés à Leadrs depuis votre cms Shopify.',
            logo: shopifyImg,
            status: 'not-setup',
            source: '',
        },
        {
            name: 'Bubble',
            service: 'bubble',
            description:
                'Vos leads automatiquement envoyés à Leadrs depuis votre cms Bubble.',
            logo: bubbleImg,
            status: 'not-setup',
            source: '',
        },
        {
            name: 'System.io',
            service: 'systemio',
            description:
                'Vos leads automatiquement envoyés à Leadrs depuis votre cms System.io.',
            logo: systemIoImg,
            status: 'not-setup',
            source: '',
        },
        {
            name: 'PrestaShop',
            service: 'prestashop',
            description:
                'Vos leads automatiquement envoyés à Leadrs depuis votre cms PrestaShop.',
            logo: prestaShopImg,
            status: 'not-setup',
            source: '',
        },
        {
            name: 'Unbounce',
            service: 'unbounce',
            description:
                'Vos leads automatiquement envoyés à Leadrs depuis unbounce.',
            logo: unbouncedImg,
            status: 'not-setup',
            source: '',
        },
        {
            name: 'Bolt',
            service: 'bolt',
            description:
                'Vos leads automatiquement envoyés à Leadrs depuis votre cms Bolt.',
            logo: boltImg,
            status: 'not-setup',
            source: '',
        },
        {
            name: 'Landbot',
            service: 'landbot',
            description:
                'Vos leads automatiquement envoyés à Leadrs depuis votre cms Landbot.',
            logo: landbotImg,
            status: 'not-setup',
            source: '',
        },
        {
            name: 'Google Sheet',
            service: 'gsheet',
            description:
                'Vos leads automatiquement envoyés à Leadrs depuis un Google Sheet.',
            logo: GsheetImg,
            status: 'not-setup',
            source: '',
        },
    ]);

    const getOffer = () => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        };
        axios
            .get(`${CONFIG.apiUrl}/offer/${params.id}`, config)
            .then((res) => {
                setOffer(res.data);
                if (!res.data.tested) {
                    setErrorMessage(
                        `Nous n'avons par encore reçu le lead de test pour cette intégration.`
                    );
                } else {
                    setErrorMessage(null);
                }
                console.log(res.data);
            })
            .catch((err) => {
                console.log('No user info found', err);
            });
    };

    const PluginCard = (props: {
        logo: any;
        name: string;
        service: string;
        description: string;
        status?: string;
        index: number;
    }) => {
        const { logo, name, description, service, status, index } = props;
        const nav = useNavigate();

        return (
            <Card
                extra={'relative w-full mt-2 px-2 py-6 border'}
                index={index + 1}
                key={index + 1}
            >
                {/* Badge */}
                {status === 'online' && (
                    <div className="absolute right-3 top-3 rounded-lg bg-green-600/80 px-2 py-1 text-xs text-white">
                        {'Connecté'}
                    </div>
                )}
                {status === 'offline' && (
                    <div className="absolute right-3 top-3 rounded-lg bg-red-600/80 px-2 py-1 text-xs text-white">
                        {'Déconnecté'}
                    </div>
                )}
                {/* {status === 'not-setup' && (
                    <div className="absolute right-3 top-3 rounded-lg bg-orange-600/80 px-2 py-1 text-xs text-white">
                        {'Non configuré'}
                    </div>
                )} */}
                {/* Header */}
                <div className="w-full px-1">
                    <img
                        src={logo}
                        alt={`${name}-logo`}
                        className="ml-1 h-[70px] w-[70px] rounded-lg border"
                    />
                    <h4 className="mt-4 text-xl font-medium">{name}</h4>
                    <p className="mt-2 text-xs">{description}</p>
                </div>
                <div className="mt-4 flex justify-center">
                    {status === 'coming-soon' && (
                        <button
                            className={`linear flex h-10 w-full cursor-not-allowed items-center justify-center rounded-xl bg-leadrs px-5 py-3 text-sm font-medium text-white`}
                        >
                            Bientôt disponible
                        </button>
                    )}
                    {status === 'not-setup' && (
                        <button
                            className={`linear flex h-10 w-full cursor-pointer items-center justify-center rounded-xl bg-leadrs px-5 py-3 text-sm font-medium text-white`}
                            onClick={() => setSelectedService(service)}
                        >
                            Intégrer {name}
                        </button>
                    )}
                    {status === 'online' && (
                        <button
                            className={`linear bg-primary flex h-10 w-full cursor-pointer items-center justify-center rounded-xl px-5 py-3 text-sm font-medium text-white`}
                            onClick={() => nav(`/integrate/${service}`)}
                        >
                            Gérer les paramètres
                        </button>
                    )}
                </div>
            </Card>
        );
    };

    const CmsChoice = () => {
        return (
            <div>
                {loading ? (
                    <div className="rounded-xl border-2 border-[#1f2937] p-10">
                        <p className="font-han mb-[80px] text-center text-2xl">
                            Chargement des extensions...
                        </p>
                    </div>
                ) : (
                    <>
                        <Card
                            extra={
                                'w-full pb-[10px] pt-[10px] px-[29px] h-fit shadow shadow-3xl rounded-[20px] border'
                            }
                        >
                            {/* Header */}
                            <div className="mt-1">
                                <p className="text-xl font-semibold text-navy-700 dark:text-white">
                                    Votre CMS 🔑
                                </p>
                                <p className="mt-2 text-base text-gray-600">
                                    Sélectionnez votre CMS pour être guidé dans
                                    l'intégration avec leadrs.
                                </p>
                            </div>
                        </Card>
                        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 lg:grid-cols-4">
                            {services.map((service, index) => (
                                <PluginCard
                                    index={index}
                                    key={service.service}
                                    name={service.name}
                                    service={service.service}
                                    description={service.description}
                                    logo={service.logo}
                                    status={service.status}
                                />
                            ))}
                        </div>
                    </>
                )}
            </div>
        );
    };

    const GoBack = () => {
        return (
            <div
                className="flex cursor-pointer items-center justify-start"
                onClick={() => setSelectedService(null)}
            >
                <svg
                    className="mr-2 h-5 w-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M15 19l-7-7 7-7"
                    />
                </svg>
                <p className="text-xs">Retour</p>
            </div>
        );
    };

    const ApiUrlDisplay = (props: {
        user: any;
        params: any;
        selectedService: any;
    }) => {
        const [copied, setCopied] = useState(false);
        const apiUrl = `https://api.leadrs.io/${user?._id}/${params.id}`;

        const handleCopy = () => {
            navigator.clipboard.writeText(apiUrl);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        };

        return (
            <div className="mt-6 w-full max-w-3xl rounded-2xl border border-gray-200 bg-white px-4 py-8 shadow-md">
                <h2 className="mb-3 text-center text-xl font-semibold text-gray-800">
                    URL de l'API
                </h2>

                <div className="relative mb-4 rounded-md bg-gray-100 px-4 py-3">
                    <p className="break-all text-center font-mono text-sm text-gray-800">
                        {apiUrl}
                    </p>
                    <button
                        onClick={handleCopy}
                        className="absolute right-3 top-3 text-sm text-gray-600 transition hover:text-gray-900"
                        title="Copier"
                    >
                        {copied ? '✅' : '📋'}
                    </button>
                </div>

                <div className="space-y-2 text-center text-sm text-gray-600">
                    <p>
                        Dans le champ{' '}
                        <code className="font-semibold text-gray-800">
                            {'Action'}
                        </code>{' '}
                        indiquez l’URL ci-dessus
                    </p>
                    <p>
                        Dans le champ{' '}
                        <code className="font-semibold text-gray-800">
                            {'Method'}
                        </code>{' '}
                        indiquez POST
                    </p>
                    <p>
                        Envoyez un lead de test avec{' '}
                        <code className="font-semibold text-gray-800">
                            {'integrate@leadrs.co'}
                        </code>{' '}
                        en email
                    </p>
                </div>
                <div className="mt-7 flex justify-center text-base">
                    {offer?.tested ? (
                        <div className="flex items-center">
                            <button
                                className="rounded-lg bg-green-600 px-4 py-2 text-white"
                                onClick={() =>
                                    (window.location.href =
                                        '/admin/integrate-offers')
                                }
                            >
                                Intégration réussie !
                            </button>
                        </div>
                    ) : (
                        <button
                            className="rounded-lg bg-leadrs px-4 py-2 text-white"
                            onClick={getOffer}
                        >
                            C'est fait ! Vérifier l'intégration
                        </button>
                    )}
                </div>
                {errorMessage && (
                    <div>
                        <p className="mt-2 flex justify-center text-sm text-red-600">
                            {errorMessage}
                        </p>
                        <p
                            className="mt-2 flex cursor-pointer justify-center gap-1 text-sm text-blue-800 underline hover:text-blue-900"
                            onClick={() =>
                                window.open('/admin/my-leads', '_blank')
                            }
                        >
                            Afficher les leads reçu par leadrs.
                        </p>
                    </div>
                )}
            </div>
        );
    };

    const initUser = () => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        };
        axios
            .get(`${CONFIG.apiUrl}/user/me`, config)
            .then((res: any) => {
                setUser(res.data);
                if (res.data && res.data.type !== 'seller') {
                    window.location.href = '/admin/my-request';
                }
                console.log(res.data);
            })
            .catch((err: any) => {
                console.log('No user info found', err);
            });
    };

    useEffect(() => {
        initUser();
    }, []);

    return (
        <div>
            {selectedService === null ? (
                <CmsChoice />
            ) : (
                <div className="">
                    <GoBack />
                    <div className="mt-5 flex flex-col items-center justify-center">
                        <img
                            src={
                                services.find(
                                    (service) =>
                                        service.service === selectedService
                                )?.logo
                            }
                            alt={`${selectedService}-logo`}
                            className="ml-1 h-[70px] w-[70px] rounded-lg border"
                        />
                        <h4 className="mt-4 text-xl font-medium">
                            Intégration de {selectedService}
                        </h4>
                        <p className="mt-2 text-xs">
                            Suivez les étapes pour intégrer {selectedService} à
                            Leadrs.
                        </p>
                        <iframe
                            width="700px"
                            height="400px"
                            src={
                                services.find(
                                    (service) =>
                                        service.service === selectedService
                                )?.source
                            }
                            title="Comment connecter son formulaire webflow avec leadrs"
                            allow="clipboard-write"
                            className="mt-4"
                            sandbox="allow-popups allow-popups-to-escape-sandbox allow-scripts allow-forms allow-same-origin allow-presentation"
                        ></iframe>
                        <p className="display: none"></p>
                        {/* Improved UI/UX for displaying API URL */}
                        <ApiUrlDisplay
                            user={user}
                            params={params}
                            selectedService={selectedService}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default IntegrateSpecificOffer;
